/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ChangePasswordRequest {
    getFixupPrototypeFunction() { return ChangePasswordRequest.fixupPrototype; }

    static newInstance(model: Partial<ChangePasswordRequest>): ChangePasswordRequest {
        let obj = Object.assign(new ChangePasswordRequest(), model);
        ChangePasswordRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ChangePasswordRequest>): ChangePasswordRequest {
        if (!model) return null;
        return ChangePasswordRequest.newInstance(<ChangePasswordRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ChangePasswordRequest) {
        if (!obj) return;

        models.ChangePasswordRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ChangePasswordRequest): boolean {
        Object.setPrototypeOf(obj, ChangePasswordRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Current password of the user being used. If you are unaware of the current password, use forgot password option in the CoreStack portal.
     */
    current_password: string;

    /**
     * New Password to be set for the user. Password length must be of 8-15 characters with atleast one special character(_$^@*!#&.), one number and starting character must be an alphabet.
     */
    new_password: string;

}
